import { scheduleActions, SwitchTimelinePeriodAction } from '../../actions';
import { put } from 'redux-saga/effects';
import { selectCurrentViewSaga, selectVisibleTimelinePeriodSaga } from '../../selectors-saga';

export function* switchTimelinePeriodWorker(action: SwitchTimelinePeriodAction) {
  const { periodSwitch } = action.payload;

  const timePeriod = yield* selectVisibleTimelinePeriodSaga();
  const currentView = yield* selectCurrentViewSaga();

  const updatedTimePeriod = timePeriod.switchPeriod(currentView, periodSwitch);

  yield put(scheduleActions.setState({ switchedTimelinePeriod: updatedTimePeriod }));
}
